export const paths = ['/labor-classes', '/labor-classes/:action'];
